impersonate = function (myToken, url) {
    event.preventDefault();
    if (confirm("Deseja logar nesta conta?")) {
        let formToken = $('meta[name="csrf-token"]').attr('content');
        let input1 = $('<input type="hidden" name="_token">').val(formToken);
        let input2 = $('<input type="hidden" name="my-token">').val(myToken);
        $('<form action="' + url + '" method="post"></form>').append(input1, input2).hide().appendTo('body').submit();
    }
};



// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-impersonate-register.js